import React, { useMemo, useState } from 'react';
import './WeatherApp.css';

import search_icon from '../Assets/search.png';
import clear_icon from '../Assets/clear.png';
import cloud_icon from '../Assets/cloud.png';
import drizzle_icon from '../Assets/drizzle.png';
import rain_icon from '../Assets/rain.png';
import snow_icon from '../Assets/snow.png';
import wind_icon from '../Assets/wind.png';
import humidity_icon from '../Assets/humidity.png';

const API_KEY = 'da816109f4855993f1a17268fd2eb51d';

const iconMap = {
  '01d': clear_icon,
  '01n': clear_icon,
  '02d': cloud_icon,
  '02n': cloud_icon,
  '03d': drizzle_icon,
  '03n': drizzle_icon,
  '04d': drizzle_icon,
  '04n': drizzle_icon,
  '09d': rain_icon,
  '09n': rain_icon,
  '10d': rain_icon,
  '10n': rain_icon,
  '13d': snow_icon,
  '13n': snow_icon,
};

const defaultWeather = {
  location: 'Kolkata',
  temperature: 22,
  humidity: 58,
  wind: 25,
  conditionIconCode: '02d',
  description: 'Cloudy',
};

const WeatherApp = () => {
  const [city, setCity] = useState('');
  const [activeTab, setActiveTab] = useState('overview');
  const [weather, setWeather] = useState(defaultWeather);

  const weatherIcon = useMemo(
    () => iconMap[weather.conditionIconCode] || clear_icon,
    [weather.conditionIconCode],
  );

  const search = async () => {
    if (!city.trim()) return;

    const url = `https://api.openweathermap.org/data/2.5/weather?q=${encodeURIComponent(city)}&units=Metric&appid=${API_KEY}`;
    const response = await fetch(url);
    const data = await response.json();

    if (!response.ok || !data?.weather?.[0] || !data?.main || !data?.wind) return;

    setWeather({
      location: data.name,
      temperature: Math.floor(data.main.temp),
      humidity: data.main.humidity,
      wind: Math.floor(data.wind.speed),
      conditionIconCode: data.weather[0].icon,
      description: data.weather[0].description,
    });
  };

  return (
    <div className="container">
      <div className="top-bar">
        <input
          type="text"
          className="cityInput"
          placeholder="Search city"
          value={city}
          onChange={(event) => setCity(event.target.value)}
          onKeyDown={(event) => event.key === 'Enter' && search()}
        />
        <button className="search-icon" onClick={search} aria-label="Search weather">
          <img src={search_icon} alt="Search" />
        </button>
      </div>

      <div className="tabs" role="tablist" aria-label="Weather details tabs">
        <button
          className={`tab ${activeTab === 'overview' ? 'active' : ''}`}
          onClick={() => setActiveTab('overview')}
          role="tab"
          aria-selected={activeTab === 'overview'}
        >
          Overview
        </button>
        <button
          className={`tab ${activeTab === 'details' ? 'active' : ''}`}
          onClick={() => setActiveTab('details')}
          role="tab"
          aria-selected={activeTab === 'details'}
        >
          Details
        </button>
      </div>

      <section className="weather-panel">
        <div className="weather-image">
          <img src={weatherIcon} alt={weather.description} />
        </div>

        <div className="weather-temp">{weather.temperature}°C</div>
        <div className="weather-location">{weather.location}</div>

        {activeTab === 'overview' ? (
          <p className="description">{weather.description}</p>
        ) : (
          <div className="data-container">
            <div className="element">
              <img src={humidity_icon} alt="Humidity" className="icon" />
              <div className="data">
                <div className="humidity-percent">{weather.humidity}%</div>
                <div className="text">Humidity</div>
              </div>
            </div>
            <div className="element">
              <img src={wind_icon} alt="Wind Speed" className="icon" />
              <div className="data">
                <div className="wind-rate">{weather.wind} KM/H</div>
                <div className="text">Wind Speed</div>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default WeatherApp;
